import type { ReactNode } from "react";

/** Kartu standar dashboard: ikon + judul + hint + aksi kanan. */
export function Panel({ icon, title, hint, action, children, flush, style }: {
  icon?: string; title: ReactNode; hint?: string; action?: ReactNode; children: ReactNode; flush?: boolean; style?: React.CSSProperties;
}) {
  return (
    <section className="avio-panel" style={style}>
      <div className="avio-panel__head">
        {icon && <span className="avio-panel__ico"><i className={icon} /></span>}
        <span className="avio-panel__title">{title}</span>
        {hint && <span className="avio-panel__hint">{hint}</span>}
        {action && <span className="avio-panel__act">{action}</span>}
      </div>
      <div className="avio-panel__body" data-flush={flush ? "true" : undefined}>{children}</div>
    </section>
  );
}
